import { isObjectValue } from '@direct-frontend/stdlib';

/**
 * Проверяет, что все значения в массиве соответствуют ValueType
 * @typeParam ValueType Тип строковых значений
 * @param values Проверяемые значения
 * @param valueType Объект с допустимыми значениями ValueType.
 * Если объект не передан, ValueType считается string
 * @returns Соответствуют ли все значения ValueType
 * @kind helper
 */
export function isValuesOfValueType<ValueType extends string = string>(
    values: string[],
    valueType?: Record<string, ValueType>
): values is ValueType[] {
    return !valueType || values.every(value => isObjectValue(value, valueType));
}
